import React from "react";
import { Helmet } from "react-helmet-async";
import logo from "../assets/logo-impact-founders.svg";

export default function Home() {
  return (
    <>
      <Helmet>
        <title>Impact Founders</title>
        <meta
          name="description"
          content="Vous souhaitez échanger sur un projet d'innovation au service de la transition du secteur immobilier & bâtiment ? Contactez-nous."
        />
        <meta property="og:title" content="Impact Founders" />
        <meta
          property="og:description"
          content="Vous souhaitez échanger sur un projet d'innovation au service de la transition du secteur immobilier & bâtiment ? Contactez-nous."
        />
        <meta property="og:url" content="https://impact-founders.com/" />
        <link rel="canonical" href="https://impact-founders.com/" />
      </Helmet>

      <div className="bg-primary-dark min-h-screen font-sans flex flex-col items-center justify-center px-6 py-10">
        <img
          src={logo}
          alt="Impact Founders"
          className="w-full max-w-[18rem] md:max-w-xl h-auto brightness-0 invert"
        />

        <p className="mt-8 mb-8 max-w-lg text-center !text-beige/90 !font-sans text-base md:text-lg leading-relaxed">
          Vous souhaitez échanger sur un projet d&apos;innovation au service de
          la transition du secteur immobilier &amp; bâtiment&nbsp;?
        </p>

        <a
          href="mailto:lukas@impact-founders.com"
          className="font-sans text-sm tracking-wide text-beige/80 border border-beige/40 px-8 py-3 hover:bg-beige hover:text-primary-dark transition-colors"
        >
          Contactez-nous
        </a>
      </div>
    </>
  );
}
